module.exports = __webpack_public_path__ + "static/img/bgimg2-2.25c3721a.png";